import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import sendLog from './sendLog';
import { getGlobal } from '../utils/global';

function sendError(e) {
  if (typeof PromiseRejectionEvent !== 'undefined' && e instanceof PromiseRejectionEvent) {
    processUnhandledRejection(e);
  } else {
    processError.apply(null, arguments);
  }
}

function processError(e, filename, lineno, colno, error) {
  try {
    if (typeof e === 'string') {
      sendLog({
        message: e,
        filename: filename,
        lineno: lineno,
        colno: colno,
        error: error
      });
      return;
    }

    sendLog(e);
  } catch (e) {}
}

function processUnhandledRejection(e) {
  if (!e) return;

  try {
    var message = '';
    var lineno = 0;
    var colno = 0;
    var filename = '';
    var stack = '';
    var reason = typeof e === 'string' ? e : e.reason;
    var AES = getGlobal('AES');
    var processPromiseRejectReason = AES.getConfig('plugin_js_error_processPromiseRejectReason');

    if (typeof processPromiseRejectReason === 'function') {
      reason = processPromiseRejectReason(reason);

      if (reason === false || reason === undefined || reason === '' || reason === null) {
        return;
      }
    } // 处理message


    if (typeof e.message === 'string') {
      message = e.message;
    }

    if (typeof reason === 'string') {
      message = reason;
    } else if (typeof reason === 'object') {
      message = reason.message;
    }

    try {
      if (!message) {
        message = typeof reason === 'object' ? _JSON$stringify(reason).substr(0, 150) : message;
      }
    } catch (e) {} // 处理剩余信息


    if (typeof reason === 'object') {
      if (typeof reason.column === 'number') {
        colno = reason.column;
        lineno = reason.line;
      } else if (reason.stack) {
        var matchR = reason.stack.match(/at\s+.+:(\d+):(\d+)/);

        if (matchR) {
          lineno = matchR[1];
          colno = matchR[2];
        }
      }

      if (reason.sourceURL) {
        filename = reason.sourceURL;
      } else if (reason.stack) {
        var matchR = reason.stack.match(/at\s+(.+):\d+:\d+/);

        if (matchR) {
          filename = matchR[1];
        }
      }

      if (reason.stack) {
        stack = reason.stack;
      }
    }

    sendLog({
      message: message,
      filename: filename,
      lineno: lineno,
      colno: colno,
      stack: stack,
      error_type: e.constructor.name
    });
  } catch (e) {}
}

export default {
  sendError: sendError,
  processError: processError,
  processUnhandledRejection: processUnhandledRejection
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-jserror@1.0.13@@ali/aes-tracker-plugin-jserror/es/libs/index.js
// module id = null
// module chunks = 